import React, { Component, useState, useRef, useEffect } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, OverlayTrigger, Popover, Overlay, ListGroup, ListGroupItem } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';

import '../../css/NotificationPopper.css'
import Swal from 'sweetalert2/dist/sweetalert2.js';
// import axiosConfig from "../config/axiosConfig";
import axiosConfig from "./../../config/axiosConfig";
import { Link } from 'react-router-dom';

function NotificationPopper() {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [notificationCount, setNotificationCount] = useState();
  const ref = useRef(null);
  const [notificationList, setNotificationList] = useState([]);

  useEffect(() => {
    let mounted = true;

    axiosConfig.post("Portal/GetNotificationSummaryForPortal")
      .then(Response => {

        setNotificationCount(Response.data.notificationCount)
        setNotificationList(Response.data._NotificationSummary)
      })
      .catch(error => {
        Swal.fire({
          title: error.response.data.errorMessage,
          text: 'Some Error !',
          icon: 'error',
          confirmButtonText: 'Okay'
        })
      })
    return () => mounted = false;
  }, [])

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  return (
    <div ref={ref} style={{ cursor: 'pointer' }}>
      <span >
        <div onClick={handleClick}>
          <FeatherIcon icon="bell" size="20" />
          {notificationCount != 0 &&
            <span className="notificationbadge badge badge-pill badge-danger">{notificationCount}</span>
          }
        </div>
      </span>
      <Overlay
        show={show}
        target={target}
        placement="bottom"
        container={ref.current}
        containerPadding={60}
        rootClose

      >
        <Popover id="popover-contained">

          <Popover.Title className="text-white text-center" style={{ padding: '15px', backgroundColor: '#626262' }}> <h4>{notificationCount} New </h4><small>App Notifications</small></Popover.Title>

          <Popover.Content>
            <div>
              <div>
                {
                  notificationList.map(
                    (item, index) => (
                      <>
                        <Row >
                          <Col xs={1} className="p-0">
                            <FeatherIcon color="red" icon="bell" size="20" />
                          </Col>

                          <Col xs={8} className="p-0">
                            <div>
                              <h6 className="danger media-heading yellow darken-3">{item.messageHeader}!</h6>
                              <small className="notification-text"> {item.messageBody}</small>
                            </div>
                          </Col>
                          <Col xs={3} className="p-0 text-center">
                            <small>
                              <time className="media-meta" dateTime="2015-06-11T18:29:20+08:00">{item.dateTime}</time>
                            </small>
                          </Col>
                        </Row>
                        <hr />
                      </>
                    )
                  )
                }
              </div>
              <div className="text-center">
                <Link to="./Notifications">Read all notifications</Link>
              </div>
            </div>
          </Popover.Content>
        </Popover>
      </Overlay>
    </div >
  );
}

export default NotificationPopper